import React from 'react';
import { ReactComponent as ErrorIcon } from '../../assets/novosicones/ErrorIcon.svg';
import { ContainerAlertErrorMessage } from './styles';

const AlertErrorMessage = ({
  message,
  title,
  height,
  position,
  top,
  left,
  right,
  textAlign,
  marginTop,
  marginBottom,
}) => {
  return (
    <ContainerAlertErrorMessage
      height={height}
      position={position}
      top={top}
      left={left}
      right={right}
      textAlign={textAlign}
      marginTop={marginTop}
      marginBottom={marginBottom}
    >
      <ErrorIcon width={48} />

      <span>
        {title && <b>{title}</b>} {message}
      </span>
    </ContainerAlertErrorMessage>
  );
};

export default AlertErrorMessage;
